/*
  FD26 Add to Bag handler.
  Intercepts clicks on any .fd26-add-to-cart-btn, posts to Shopify's /cart/add.js
  AJAX endpoint instead of navigating to the product page, and gives inline
  button feedback. Falls back to navigating to the product page if the add
  fails for any reason (e.g. sold out variant), so the customer is never stuck.
*/
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.fd26-add-to-cart-btn');
  if (!btn) return;

  var variantId = btn.getAttribute('data-variant-id');
  var fallbackUrl = btn.getAttribute('data-fallback-url');

  // No real variant available (no product assigned yet, or sold out with no fallback variant)
  if (!variantId) {
    if (fallbackUrl) window.location.href = fallbackUrl;
    return;
  }

  e.preventDefault();

  var originalText = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adding...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(function (res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(function () {
      btn.textContent = 'Added \u2713';

      // Best-effort refresh of common cart-count elements across themes.
      // Harmless no-op if none of these selectors exist on this theme.
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document
            .querySelectorAll('[data-cart-count], .cart-count-bubble, #cart-icon-bubble, .cart-count')
            .forEach(function (el) {
              el.textContent = cart.item_count;
            });
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
        })
        .catch(function () {});

      setTimeout(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1800);
    })
    .catch(function () {
      btn.textContent = originalText;
      btn.disabled = false;
      if (fallbackUrl) window.location.href = fallbackUrl;
    });
});
